import { ApiResponses } from 'lib/trpcClient';
import { DataRoomFormData, defaultData } from './formData';

export const mapDataRoomResponseToFormData = (
  data:
    | ApiResponses['dataRoom']['getById']
    | ApiResponses['dataRoom']['update'],
): DataRoomFormData => {
  return {
    status: data.status,
    headline: data.headline ?? defaultData.headline,
    subheading: data.subheading ?? defaultData.subheading,
    contact: data.contact
      ? {
          name: data.contact.name,
          email: data.contact.email,
          phone: data.contact.phone,
          image: data.contact.image.objectKey
            ? {
                fileName: 'Uploaded file',
                uri: data.contact.image.uri,
                objectKey: data.contact.image.objectKey,
              }
            : null,
        }
      : defaultData.contact,
    keyInformation:
      data.keyInformation.length > 0
        ? data.keyInformation
        : defaultData.keyInformation,
  };
};
